// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm-button[data-v-5ace82a6] {\n  display: inline-block;\n}\n.confirm-button-context[data-v-5ace82a6] {\n  margin: 10px;\n}\n.confirm-button-btn-group[data-v-5ace82a6] {\n  text-align: right;\n  margin: 10px 0;\n}\n.confirm-popover[data-v-5ace82a6] {\n  padding: 10px !important;\n}\n.el-button-group .confirm-button[data-v-5ace82a6] {\n  float: left;\n}\n", ""]);
// Exports
module.exports = exports;
